export default [
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "enum IPairsManager.PairType",
        "name": "pairType",
        "type": "uint8"
      },
      {
        "indexed": true,
        "internalType": "enum IPairsManager.PairStatus",
        "name": "status",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "slippageConfigIndex",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "uint16",
        "name": "feeConfigIndex",
        "type": "uint16"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "name",
        "type": "string"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "notionalUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint16",
            "name": "tier",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxLeverage",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "initialLostP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "liqLostP",
            "type": "uint16"
          }
        ],
        "indexed": false,
        "internalType": "struct LibPairsManager.LeverageMargin[]",
        "name": "leverageMargins",
        "type": "tuple[]"
      }
    ],
    "name": "AddPair",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      }
    ],
    "name": "RemovePair",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint16",
        "name": "oldFeeConfigIndex",
        "type": "uint16"
      },
      {
        "indexed": true,
        "internalType": "uint16",
        "name": "feeConfigIndex",
        "type": "uint16"
      }
    ],
    "name": "UpdatePairFee",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "oldfundingFeePerSecondP",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "oldMinFundingFeeR",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "oldMaxFundingFeeR",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "fundingFeePerSecondP",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "minFundingFeeR",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "maxFundingFeeR",
        "type": "uint256"
      }
    ],
    "name": "UpdatePairFundingFeeConfig",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint40",
        "name": "oldLongRate",
        "type": "uint40"
      },
      {
        "indexed": false,
        "internalType": "uint40",
        "name": "oldShortRate",
        "type": "uint40"
      },
      {
        "indexed": false,
        "internalType": "uint40",
        "name": "longRate",
        "type": "uint40"
      },
      {
        "indexed": false,
        "internalType": "uint40",
        "name": "shortRate",
        "type": "uint40"
      }
    ],
    "name": "UpdatePairHoldingFeeRate",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "notionalUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint16",
            "name": "tier",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxLeverage",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "initialLostP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "liqLostP",
            "type": "uint16"
          }
        ],
        "indexed": false,
        "internalType": "struct LibPairsManager.LeverageMargin[]",
        "name": "leverageMargins",
        "type": "tuple[]"
      }
    ],
    "name": "UpdatePairLeverageMargin",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "oldMaxLongOiUsd",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "oldMaxShortOiUsd",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "maxLongOiUsd",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "maxShortOiUsd",
        "type": "uint256"
      }
    ],
    "name": "UpdatePairMaxOi",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "oldMinHoldingSeconds",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "oldHoldingTimeThresholdSizeUSD",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "minHoldingSeconds",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "holdingTimeThresholdSizeUSD",
        "type": "uint256"
      }
    ],
    "name": "UpdatePairMinHoldingSeconds",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint16",
        "name": "oldSlippageConfigIndexed",
        "type": "uint16"
      },
      {
        "indexed": true,
        "internalType": "uint16",
        "name": "slippageConfigIndex",
        "type": "uint16"
      }
    ],
    "name": "UpdatePairSlippage",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "enum IPairsManager.PairStatus",
        "name": "oldStatus",
        "type": "uint8"
      },
      {
        "indexed": true,
        "internalType": "enum IPairsManager.PairStatus",
        "name": "status",
        "type": "uint8"
      }
    ],
    "name": "UpdatePairStatus",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "string",
        "name": "name",
        "type": "string"
      },
      {
        "internalType": "enum IPairsManager.PairType",
        "name": "pairType",
        "type": "uint8"
      },
      {
        "internalType": "enum IPairsManager.PairStatus",
        "name": "status",
        "type": "uint8"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "maxLongOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxShortOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "fundingFeePerSecondP",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "minFundingFeeR",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxFundingFeeR",
            "type": "uint256"
          }
        ],
        "internalType": "struct PairMaxOiAndFundingFeeConfig",
        "name": "pairConfig",
        "type": "tuple"
      },
      {
        "internalType": "uint16",
        "name": "slippageConfigIndex",
        "type": "uint16"
      },
      {
        "internalType": "uint16",
        "name": "feeConfigIndex",
        "type": "uint16"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "notionalUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint16",
            "name": "tier",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxLeverage",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "initialLostP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "liqLostP",
            "type": "uint16"
          }
        ],
        "internalType": "struct LibPairsManager.LeverageMargin[]",
        "name": "leverageMargins",
        "type": "tuple[]"
      },
      {
        "internalType": "uint40",
        "name": "longHoldingFeeRate",
        "type": "uint40"
      },
      {
        "internalType": "uint40",
        "name": "shortHoldingFeeRate",
        "type": "uint40"
      }
    ],
    "name": "addPair",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "address",
            "name": "base",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "fundingFeePerSecondP",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "minFundingFeeR",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxFundingFeeR",
            "type": "uint256"
          }
        ],
        "internalType": "struct IPairsManager.UpdatePairFundingFeeConfigParam[]",
        "name": "params",
        "type": "tuple[]"
      }
    ],
    "name": "batchUpdatePairFundingFeeConfig",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "address",
            "name": "base",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "maxLongOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxShortOiUsd",
            "type": "uint256"
          }
        ],
        "internalType": "struct IPairsManager.UpdatePairMaxOiParam[]",
        "name": "params",
        "type": "tuple[]"
      }
    ],
    "name": "batchUpdatePairMaxOi",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "bases",
        "type": "address[]"
      },
      {
        "internalType": "enum IPairsManager.PairStatus",
        "name": "status",
        "type": "uint8"
      }
    ],
    "name": "batchUpdatePairStatus",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      }
    ],
    "name": "getPairByBaseV4",
    "outputs": [
      {
        "components": [
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "address",
            "name": "base",
            "type": "address"
          },
          {
            "internalType": "uint16",
            "name": "basePosition",
            "type": "uint16"
          },
          {
            "internalType": "enum IPairsManager.PairType",
            "name": "pairType",
            "type": "uint8"
          },
          {
            "internalType": "enum IPairsManager.PairStatus",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "maxLongOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxShortOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "fundingFeePerSecondP",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "minFundingFeeR",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxFundingFeeR",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "notionalUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint16",
                "name": "tier",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "maxLeverage",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "initialLostP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "liqLostP",
                "type": "uint16"
              }
            ],
            "internalType": "struct LibPairsManager.LeverageMargin[]",
            "name": "leverageMargins",
            "type": "tuple[]"
          },
          {
            "internalType": "uint16",
            "name": "slippageConfigIndex",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "slippagePosition",
            "type": "uint16"
          },
          {
            "components": [
              {
                "internalType": "string",
                "name": "name",
                "type": "string"
              },
              {
                "internalType": "uint256",
                "name": "onePercentDepthAboveUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "onePercentDepthBelowUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint16",
                "name": "slippageLongP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "slippageShortP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "index",
                "type": "uint16"
              },
              {
                "internalType": "enum SlippageType",
                "name": "slippageType",
                "type": "uint8"
              },
              {
                "internalType": "bool",
                "name": "enable",
                "type": "bool"
              },
              {
                "internalType": "uint256",
                "name": "longThresholdUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "shortThresholdUsd",
                "type": "uint256"
              }
            ],
            "internalType": "struct LibPairsManager.SlippageConfig",
            "name": "slippageConfig",
            "type": "tuple"
          },
          {
            "internalType": "uint16",
            "name": "feeConfigIndex",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "feePosition",
            "type": "uint16"
          },
          {
            "components": [
              {
                "internalType": "string",
                "name": "name",
                "type": "string"
              },
              {
                "internalType": "uint16",
                "name": "index",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "openFeeP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "closeFeeP",
                "type": "uint16"
              },
              {
                "internalType": "bool",
                "name": "enable",
                "type": "bool"
              },
              {
                "internalType": "uint24",
                "name": "shareP",
                "type": "uint24"
              },
              {
                "internalType": "uint24",
                "name": "minCloseFeeP",
                "type": "uint24"
              },
              {
                "internalType": "uint24",
                "name": "lvTokenDiscountP",
                "type": "uint24"
              }
            ],
            "internalType": "struct LibFeeManager.FeeConfig",
            "name": "feeConfig",
            "type": "tuple"
          },
          {
            "internalType": "uint40",
            "name": "longHoldingFeeRate",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "shortHoldingFeeRate",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "holdingTimeThresholdSizeUSD",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "minHoldingSeconds",
            "type": "uint256"
          }
        ],
        "internalType": "struct IPairsManager.PairView",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      }
    ],
    "name": "getPairConfig",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "maxLongOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxShortOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "fundingFeePerSecondP",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "minFundingFeeR",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxFundingFeeR",
            "type": "uint256"
          }
        ],
        "internalType": "struct PairMaxOiAndFundingFeeConfig",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      }
    ],
    "name": "getPairFeeConfig",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint16",
            "name": "openFeeP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "closeFeeP",
            "type": "uint16"
          },
          {
            "internalType": "uint24",
            "name": "shareP",
            "type": "uint24"
          },
          {
            "internalType": "uint24",
            "name": "minCloseFeeP",
            "type": "uint24"
          },
          {
            "internalType": "uint24",
            "name": "lvTokenDiscountP",
            "type": "uint24"
          }
        ],
        "internalType": "struct IPairsManager.FeeConfig",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      }
    ],
    "name": "getPairForTrading",
    "outputs": [
      {
        "components": [
          {
            "internalType": "address",
            "name": "base",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "enum IPairsManager.PairType",
            "name": "pairType",
            "type": "uint8"
          },
          {
            "internalType": "enum IPairsManager.PairStatus",
            "name": "status",
            "type": "uint8"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "maxLongOiUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "maxShortOiUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "fundingFeePerSecondP",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "minFundingFeeR",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "maxFundingFeeR",
                "type": "uint256"
              }
            ],
            "internalType": "struct PairMaxOiAndFundingFeeConfig",
            "name": "pairConfig",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "notionalUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint16",
                "name": "maxLeverage",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "initialLostP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "liqLostP",
                "type": "uint16"
              }
            ],
            "internalType": "struct IPairsManager.LeverageMargin[]",
            "name": "leverageMargins",
            "type": "tuple[]"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "onePercentDepthAboveUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "onePercentDepthBelowUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint16",
                "name": "slippageLongP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "slippageShortP",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "longThresholdUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "shortThresholdUsd",
                "type": "uint256"
              },
              {
                "internalType": "enum SlippageType",
                "name": "slippageType",
                "type": "uint8"
              }
            ],
            "internalType": "struct SlippageConfigView",
            "name": "slippageConfig",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint16",
                "name": "openFeeP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "closeFeeP",
                "type": "uint16"
              },
              {
                "internalType": "uint24",
                "name": "shareP",
                "type": "uint24"
              },
              {
                "internalType": "uint24",
                "name": "minCloseFeeP",
                "type": "uint24"
              },
              {
                "internalType": "uint24",
                "name": "lvTokenDiscountP",
                "type": "uint24"
              }
            ],
            "internalType": "struct IPairsManager.FeeConfig",
            "name": "feeConfig",
            "type": "tuple"
          }
        ],
        "internalType": "struct IPairsManager.TradingPair",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "isLong",
        "type": "bool"
      }
    ],
    "name": "getPairHoldingFeeRate",
    "outputs": [
      {
        "internalType": "uint40",
        "name": "holdingFeeRate",
        "type": "uint40"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      }
    ],
    "name": "getPairSlippageConfig",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "onePercentDepthAboveUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "onePercentDepthBelowUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint16",
            "name": "slippageLongP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "slippageShortP",
            "type": "uint16"
          },
          {
            "internalType": "uint256",
            "name": "longThresholdUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "shortThresholdUsd",
            "type": "uint256"
          },
          {
            "internalType": "enum SlippageType",
            "name": "slippageType",
            "type": "uint8"
          }
        ],
        "internalType": "struct SlippageConfigView",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "pairsV4",
    "outputs": [
      {
        "components": [
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "address",
            "name": "base",
            "type": "address"
          },
          {
            "internalType": "uint16",
            "name": "basePosition",
            "type": "uint16"
          },
          {
            "internalType": "enum IPairsManager.PairType",
            "name": "pairType",
            "type": "uint8"
          },
          {
            "internalType": "enum IPairsManager.PairStatus",
            "name": "status",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "maxLongOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxShortOiUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "fundingFeePerSecondP",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "minFundingFeeR",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "maxFundingFeeR",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "notionalUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint16",
                "name": "tier",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "maxLeverage",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "initialLostP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "liqLostP",
                "type": "uint16"
              }
            ],
            "internalType": "struct LibPairsManager.LeverageMargin[]",
            "name": "leverageMargins",
            "type": "tuple[]"
          },
          {
            "internalType": "uint16",
            "name": "slippageConfigIndex",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "slippagePosition",
            "type": "uint16"
          },
          {
            "components": [
              {
                "internalType": "string",
                "name": "name",
                "type": "string"
              },
              {
                "internalType": "uint256",
                "name": "onePercentDepthAboveUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "onePercentDepthBelowUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint16",
                "name": "slippageLongP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "slippageShortP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "index",
                "type": "uint16"
              },
              {
                "internalType": "enum SlippageType",
                "name": "slippageType",
                "type": "uint8"
              },
              {
                "internalType": "bool",
                "name": "enable",
                "type": "bool"
              },
              {
                "internalType": "uint256",
                "name": "longThresholdUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "shortThresholdUsd",
                "type": "uint256"
              }
            ],
            "internalType": "struct LibPairsManager.SlippageConfig",
            "name": "slippageConfig",
            "type": "tuple"
          },
          {
            "internalType": "uint16",
            "name": "feeConfigIndex",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "feePosition",
            "type": "uint16"
          },
          {
            "components": [
              {
                "internalType": "string",
                "name": "name",
                "type": "string"
              },
              {
                "internalType": "uint16",
                "name": "index",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "openFeeP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "closeFeeP",
                "type": "uint16"
              },
              {
                "internalType": "bool",
                "name": "enable",
                "type": "bool"
              },
              {
                "internalType": "uint24",
                "name": "shareP",
                "type": "uint24"
              },
              {
                "internalType": "uint24",
                "name": "minCloseFeeP",
                "type": "uint24"
              },
              {
                "internalType": "uint24",
                "name": "lvTokenDiscountP",
                "type": "uint24"
              }
            ],
            "internalType": "struct LibFeeManager.FeeConfig",
            "name": "feeConfig",
            "type": "tuple"
          },
          {
            "internalType": "uint40",
            "name": "longHoldingFeeRate",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "shortHoldingFeeRate",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "holdingTimeThresholdSizeUSD",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "minHoldingSeconds",
            "type": "uint256"
          }
        ],
        "internalType": "struct IPairsManager.PairView[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      }
    ],
    "name": "removePair",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "openSafeMode",
        "type": "bool"
      },
      {
        "internalType": "address[]",
        "name": "bases",
        "type": "address[]"
      },
      {
        "components": [
          {
            "internalType": "address",
            "name": "base",
            "type": "address"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "notionalUsd",
                "type": "uint256"
              },
              {
                "internalType": "uint16",
                "name": "tier",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "maxLeverage",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "initialLostP",
                "type": "uint16"
              },
              {
                "internalType": "uint16",
                "name": "liqLostP",
                "type": "uint16"
              }
            ],
            "internalType": "struct LibPairsManager.LeverageMargin[]",
            "name": "leverageMargins",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct IPairsManager.UpdateLeverageParam[]",
        "name": "updateLeverages",
        "type": "tuple[]"
      }
    ],
    "name": "safeMode",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "uint16",
        "name": "feeConfigIndex",
        "type": "uint16"
      }
    ],
    "name": "updatePairFee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "fundingFeePerSecondP",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "minFundingFeeR",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "maxFundingFeeR",
        "type": "uint256"
      }
    ],
    "name": "updatePairFundingFeeConfig",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "uint40",
        "name": "longHoldingFeeRate",
        "type": "uint40"
      },
      {
        "internalType": "uint40",
        "name": "shortHoldingFeeRate",
        "type": "uint40"
      }
    ],
    "name": "updatePairHoldingFeeRate",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "notionalUsd",
            "type": "uint256"
          },
          {
            "internalType": "uint16",
            "name": "tier",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "maxLeverage",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "initialLostP",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "liqLostP",
            "type": "uint16"
          }
        ],
        "internalType": "struct LibPairsManager.LeverageMargin[]",
        "name": "leverageMargins",
        "type": "tuple[]"
      }
    ],
    "name": "updatePairLeverageMargin",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "maxLongOiUsd",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "maxShortOiUsd",
        "type": "uint256"
      }
    ],
    "name": "updatePairMaxOi",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "minHoldingSeconds",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "holdingTimeThresholdSizeUSD",
        "type": "uint256"
      }
    ],
    "name": "updatePairMinHoldingSeconds",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "uint16",
        "name": "slippageConfigIndex",
        "type": "uint16"
      }
    ],
    "name": "updatePairSlippage",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "base",
        "type": "address"
      },
      {
        "internalType": "enum IPairsManager.PairStatus",
        "name": "status",
        "type": "uint8"
      }
    ],
    "name": "updatePairStatus",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
] as const;